module.exports = __webpack_public_path__ + "static/img/e-gudong.1151e4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/e-gudong.png
// module id = 5q5o
// module chunks = 70